<template>
    <div>
        <messages-line class="chart" v-if="this.activeChart === this.chartOptions[0]" :labels="this.labels" :dataUser="this.dataUser" :dataAgent="this.dataAgent"></messages-line>
        <messages-bar class="chart" v-if="this.activeChart === this.chartOptions[1]" :labels="this.labels" :dataUser="this.dataUser" :dataAgent="this.dataAgent"></messages-bar>
        <custom-input type="dropdown" class="dropdown" :items="this.chartOptions" :value="this.activeChart.value" @input="this.updateActiveChart"></custom-input>
    </div>
</template>

<script>
import customInput from '@/components/additional/customInput';
import messagesLine from '@/components/statistics/messages/line';
import messagesBar from '@/components/statistics/messages/bar';
import dateformat from 'dateformat';

export default {
    name: 'messages',
    components: {
        customInput,
        messagesLine,
        messagesBar
    },
    props: ['data'],
    data() {
        return {
            labels: [],
            dataUser: [],
            dataAgent: [],
            chartOptions: [
                {
                    label: 'Line',
                    value: 'line'
                },
                {
                    label: 'Bar',
                    value: 'bar'
                }
            ],
            activeChart: {}
        };
    },
    mounted() {
        this.activeChart = this.chartOptions[0];
        this.preRenderData(this.data);
    },
    watch: {
        data: function(newVal, oldVal) {
            this.preRenderData(this.data);
        }
    },
    methods: {
        preRenderData: function(data) {
            // Handle prop 'data' and render it into the chart
            let labels = [];
            let dataUser = [];
            let dataAgent = [];

            data.forEach((item) => {
                const date = new Date(item.apiDate * 1000);
                labels.push(dateformat(date, 'dddd dd-mm-yyyy'));
                dataUser.push(item.userCount ? item.userCount : 0);
                dataAgent.push(item.agentCount ? item.agentCount : 0);
            });

            this.labels = labels;
            this.dataUser = dataUser;
            this.dataAgent = dataAgent;
        },
        updateActiveChart: function(newChart) {
            if (newChart === this.chartOptions[0].value) // Line
                this.activeChart = this.chartOptions[0];
            else if (newChart === this.chartOptions[1].value) // Bar
                this.activeChart = this.chartOptions[1];
        }
    }
};
</script>

<style lang="scss" scoped>
    .custom-input {
        position: absolute;
        top: 0;
        right: 0;
        padding: 1em;
    }

    .chart {
        max-height: 100%;
        max-width: 100%;
        height: 100%;
    }
</style>